import { LiveSearchModule } from '@nirvana/shared/dtos/types/policies/common';

export interface LiveSearchFormValue {
  uiSettings: { liveSearch: LiveSearchModule };
}

export enum LiveSearchSearchableKeywords {
  LiveSearch = 'LiveSearch',
}
